














































import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

import UserAPI from '@/services/UserAPI';

import utilMixin from '@/mixin/Util';

import NewPassword from '@/form/NewPassword';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';

import Util from '@/util/Util';

export default Vue.extend({
    name: 'NewPassword',

    components: {
        Field,
        TInput
    },

    mixins: [utilMixin],

    props: {
		resetPasswordId: {
			type: String,
			default: ''
		}
    },

    created() {
        if (this.resetPasswordId && this.resetPasswordId.length === 24) {
            this.form.resetPasswordId = this.resetPasswordId;
        } else {
            this.$router.push('/');
        }
        Util.updateHeaders((this as any).$text('chooseNewPassword'), (this as any).$text('hereChooseNewPassword'), process.env.VUE_APP_DEFAULT_IMAGE);
    },

    data() {
        return {
            form: new NewPassword(),
            passwordCheck: '',
            error: {
                password: '',
                passwordCheck: '',
                save: ''
                },
            reset: false,
            isLoading: false
        };
    },

    methods: {
        resetPassword() {
            if (this.form.password === '') {
                this.error.password = (this as any).$text('missingPassword');
            } else {
                this.error.password = '';
            }

            if (this.form.password !== this.passwordCheck) {
                this.error.passwordCheck = (this as any).$text('passwordCheckNoMatch');
            } else {
                this.error.passwordCheck = '';
            }

            if (!this.form.resetPasswordId || this.form.resetPasswordId.length !== 24) {
                this.error.save = (this as any).$text('missingResetCode');
            } else {
                this.error.save = '';
            }

            if (this.error.password === '' && this.error.passwordCheck === '' && this.error.save === '') {

                const handleResponse = (response: AxiosResponse) => {
                        this.reset = true;
                    };

                const handleError = (error: AxiosError) => {
                        if (error.response) {
                            this.error.save = error.response.data.message;
                        }
                    };

                this.error.save = '';
                this.isLoading = true;
                UserAPI
                    .setPassword(this.form)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isLoading = false);
            }
        }
    }
});
